import { View, RadioGroup, Button } from "@/components/ui";
import { useBookingState } from "@/store/booking/useBookingState";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { ListHeading } from "@/components/shared/list-header";
import { Cube } from "@/components/shared/icons";
import { useEffect, useMemo } from "react";
import { lashesUnitTypeOptions } from "@/constants/booking";
import { formatPrice } from "@/lib/helpers/number";
import { showToast } from "@/components/ui/toast/show-toast";
import { useBookingRoute } from "@/components/hooks/use-booking-route";
import { Typography } from "@/components/shared/typography";
import { ServiceRadioCard } from "../../service-radio-card";
import type { PackageUnitTypeEnum } from "@/__generated__/graphql";

export const LashesServiceModal = () => {
  const { forward } = useBookingRoute();
  const {
    data: { chooseServicePackageModal, packageDetailsFilter },
    setBookingState,
  } = useBookingState();

  const unit = useMemo(() => {
    return packageDetailsFilter.unitTypes?.[0];
  }, [packageDetailsFilter.unitTypes?.[0]]);

  useEffect(() => {
    if (chooseServicePackageModal) {
      setBookingState({
        packageDetailsFilter: {
          ...packageDetailsFilter,
          unitTypes: [lashesUnitTypeOptions[0].value],
        },
      });
    }
  }, [chooseServicePackageModal]);

  const onSelect = (value: PackageUnitTypeEnum) => {
    setBookingState({
      packageDetailsFilter: {
        ...packageDetailsFilter,
        unitTypes: [value],
      },
    });
  };

  const onContinue = () => {
    if (!unit) {
      return showToast({
        title: "Please choose your package!",
        type: "info",
      });
    }
    setBookingState({
      chooseServicePackageModal: false,
    });
    forward();
  };

  return (
    <BottomDrawerModal
      open={chooseServicePackageModal}
      onOpenChange={() => {
        setBookingState({
          chooseServicePackageModal: false,
        });
      }}
    >
      <View className="flex flex-col gap-4">
        <ListHeading title="Choose Your Lash Service" icon={Cube} />
        <Typography variant="body-sm" color="foreground-intermediate">
          Enhance your look with the perfect lash style.
        </Typography>
        <RadioGroup value={unit} onValueChange={() => {}}>
          {lashesUnitTypeOptions.map((option) => (
            <ServiceRadioCard
              title={option.title}
              subTitle={`from ${formatPrice(option.startPrice, 0)} / session`}
              thirdTitle={`${option.duration} mins`}
              active={unit === option.value}
              imgUrl={option.imgUrl}
              value={option.value}
              onSelect={() => {
                onSelect(option.value);
              }}
            />
          ))}
        </RadioGroup>

        <Button
          variant="primary"
          color="CTA"
          size="lg"
          rounded="full"
          onClick={onContinue}
          children="Continue"
        />
      </View>
    </BottomDrawerModal>
  );
};
